import { createClient } from '@supabase/supabase-js';

// Replace with your actual Supabase credentials
const supabaseUrl = 'https://znqxsofyvwflijqrscwd.supabase.co';
const supabaseKey = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InpucXhzb2Z5dndmbGlqcXJzY3dkIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NTA5NTk0OTUsImV4cCI6MjA2NjUzNTQ5NX0.cHt-jmaGjWbVYk4ud8OfhVQ6p20aGAgzwoeWJeVbaEQ';

if (!supabaseUrl || !supabaseKey || supabaseUrl.includes('YOUR_') || supabaseKey.includes('YOUR_')) {
    console.error('⚠️ Supabase credentials not configured. Please replace YOUR_SUPABASE_URL and YOUR_SUPABASE_ANON_KEY in src/lib/supabase.js');
}

export const supabase = createClient(supabaseUrl, supabaseKey, {
    auth: {
        persistSession: true,
        autoRefreshToken: true,
        detectSessionInUrl: false
    }
});

// Helper functions
export async function getCurrentUser() {
    const { data: { user }, error } = await supabase.auth.getUser();
    if (error) {
        console.error('Error getting user:', error);
        return null;
    }
    return user;
}

export async function signOut() {
    const { error } = await supabase.auth.signOut();
    if (error) {
        console.error('Error signing out:', error);
    }
}